import { InputBase, InputBaseProps, SxProps } from "@mui/material";
import { FunctionComponent } from "react";
import WrapControl from "../base/WrapControl";



interface Props extends InputBaseProps {
	helperText?: string
	readOnly?: boolean
	sx?: SxProps
}

const TextField: FunctionComponent<Props> = ({
	helperText,
	sx,
	readOnly,
	...props
}) => {

	return (
		<WrapControl sx={sx}
			readOnly={readOnly}
			helperText={helperText}
		>
			<InputBase fullWidth
				autoComplete='off'
				type="text"
				readOnly={readOnly}
				{...props}
			/>
		</WrapControl>
	)
}

export default TextField
